import styled from "styled-components";


export const Label = styled.label`
color: var(--Dark-Blue-100, #002E5C);
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--MultiSelectLabelFont-family);
font-size: 14px;
font-style: normal;
font-weight: bold;
line-height: 150%; 
display: flex;
justify-content: space-between;
width:100%;
span:nth-child(2){
color: #4d5565;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 150%; 
}
`
export const InputFieldWrapper = styled.div`
  position: relative;
`
export const InputField = styled.input`
    padding: 8px 16px;
  font-size: 16px;
  border: 1px solid var(--Gray-40, #E1E1E7);
  border-radius: 5px;
  background: var(--White-100, #FFF);
  color: #333;
  width: 312px;
  height: 48px;
  justify-content: space-between;
  align-items: center;
  ::placeholder{
    color: var(--Dark-Blue-40, #99ABBE);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: var(--MultiSelectInputFieldPlaceholderFont-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }
`
export const Arrow = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  font-size: 20px;
  color: #333;
`
export const List = styled.ul`
width: 312px;
max-height: 175px;
list-style-type: none;
border-radius: 5px;
border: 1px solid var(--Dark-Blue-10, #E6EAEF);
background: var(--White-100, #FFF);
box-shadow: 0px 17px 20px 0px rgba(19, 30, 68, 0.08);
margin-top: 8px;
display: flex;
flex-direction: column;
padding:0;
overflow-y: auto;
`
export const LiWrapper = styled.div`

margin-top: 17px;
margin-left: 16px;
height: 100%;
div{
  display: flex;
}

`
export const ListItem = styled.li`
display: flex;
justify-content: flex-start;
align-items: center;
width: 100%;
color: var(--Dark-Blue-100, #002E5C);
font-size: 12px;
font-style: normal;
font-weight: 400;
cursor: pointer;
line-height: 32px; 
padding-top: 6px ;
padding-bottom: 7px;
p{
overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

`
export const Item = styled.div`
display: flex;
align-items: center;
justify-content: center;
span{
  margin-top: 10px;
}
`
export const Buttons = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding-left: 16px;
padding-right: 16px;

`
export const Button = styled.button`
background-color: transparent;
border: 0;
color: var(--Blue-100, #2555EF);
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--MultiSelectButtonFont-family);
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 32px;
`
export const NumberOfItems = styled.span`
color: var(--Blue-100, #2555EF);
font-family: Poppins;
font-size: 13px;
font-style: normal;
font-weight: 400;
line-height: 32px;
margin-left: 8px;
`
export const ArrowWrapper = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
`